import * as React from "react"
import { Text } from "gatsby-interface"

type SimpleSiteStepIndicatorProps = {
  activeStepNumber: number
  totalNumberOfSteps: number
}

function SimpleStepIndicator({
  activeStepNumber,
  totalNumberOfSteps,
}: SimpleSiteStepIndicatorProps) {
  return (
    <div
      css={{
        width: "100%",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
      }}
    >
      <Text size="S">
        Step {activeStepNumber} of {totalNumberOfSteps}{" "}
      </Text>
    </div>
  )
}

export default SimpleStepIndicator
